// extracted by mini-css-extract-plugin
module.exports = {"welcome__subline":"ogpbo","welcome__headline":"uQEJt"};